<template>
  <el-row type="flex" class="row-bg" justify="space-between" style="margin-bottom:10px; align-content: center; align-items: center">
    <div style="display: flex;  align-content: center; align-items: center">
      <div class="page-heading">
        <el-skeleton
          :loading="!heading"
          :rows="1"
          animated
        >
          <template slot="template">
            <el-skeleton-item variant="text" style="height: 25px;width:400px" />
          </template>
          <template>
            <div style="display: flex; gap: 20px; align-content: center; align-items: center">
              <slot name="before"></slot>
              {{ heading }}
            </div>

          </template>
        </el-skeleton>
      </div>

      <el-dialog
        title="Подсказка"
        :visible.sync="showHelp"
        width="30%"
        :close-on-click-modal="false"
      >
        <slot name="help"></slot>
      </el-dialog>
    </div>
    <div>
      <slot name="right"></slot>
    </div>
  </el-row>

</template>

<script>


export default {
  name: "page-heading",

  props: {
    heading: {
      type: String
    },
    help: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showHelp: false
    };
  },
  mounted() {
  },
  watch: {},
  methods: {}

};
</script>

<style>
.page-heading {
  font-size: 30px;
}
</style>